export default "__VITE_ASSET__DJVN7612__"